/**
 * ドメインエラー基底クラス
 * (システムとして正常に稼動しているエラー)
 */
export abstract class DomainError extends Error {
  constructor(inner?: Error) {
    super(inner?.message);
    if (inner?.stack) {
      this.stack = inner.stack;
    }
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/**
 * 404エラー
 */
export class ResourceNotFoundError extends DomainError {}

/**
 * 参照先が削除済みのエラー（詳細画面で「削除されました」表示に使用）
 * メッセージで対象名（車両／施設）を指定できる。
 */
export class ResourceDeletedError extends DomainError {
  constructor(message?: string) {
    super(message ? new Error(message) : undefined);
  }
}

/**
 * 403エラー
 */
export class ResourceForbiddenError extends DomainError {}

/**
 * 409エラー
 */
export class ResourceConflictError extends DomainError {}

/**
 * 不正なURLのエラー
 */
export class InvalidUrlError extends DomainError {}

/**
 * 401エラー
 */
export class UnauthorizedError extends DomainError {}
